// Lightweight SEO helper (no react-helmet dependency).
// Updates document.title + <meta name="description"> + Open Graph + canonical
// in one call. Reset on component unmount by tracking previous values.
const upsertMeta = (attr, key, content) => {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertLink = (rel, href) => {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export function setPageMeta({ title, description, image, type = "website", url } = {}) {
  if (title) document.title = title;
  if (description) upsertMeta("name", "description", description);
  const canonical = url || (typeof window !== "undefined" ? window.location.href : "");
  if (canonical) upsertLink("canonical", canonical);
  // Open Graph
  if (title) upsertMeta("property", "og:title", title);
  if (description) upsertMeta("property", "og:description", description);
  if (canonical) upsertMeta("property", "og:url", canonical);
  upsertMeta("property", "og:type", type);
  upsertMeta("property", "og:site_name", "The School Reports");
  if (image) upsertMeta("property", "og:image", image);
  // Twitter
  upsertMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
  if (title) upsertMeta("name", "twitter:title", title);
  if (description) upsertMeta("name", "twitter:description", description);
  if (image) upsertMeta("name", "twitter:image", image);
}
